export default "__VITE_ASSET__lve4Acck__"